var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureNewItemFilled = function SvgFeatureNewItemFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeLinecap: "miter",
    clipPath: "url(#feature-new-item-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.25,
    d: "M15.5 5.69c.395 1.415.965 2.697 1.673 3.783.871 1.335 1.971 2.4 3.23 3.027-1.259.627-2.359 1.692-3.23 3.027-.708 1.086-1.278 2.368-1.673 3.783-.395-1.415-.965-2.697-1.673-3.783-.871-1.335-1.971-2.4-3.23-3.027 1.259-.627 2.359-1.692 3.23-3.027.708-1.086 1.278-2.368 1.673-3.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.005a6.975 6.975 0 0 0-.756-1.525c-.41-.616-.918-1.13-1.499-1.48.581-.35 1.089-.864 1.5-1.48.3-.452.555-.965.755-1.525.2.56.454 1.073.756 1.525.41.616.918 1.13 1.499 1.48-.581.35-1.089.864-1.5 1.48A6.975 6.975 0 0 0 5 9.005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "feature-new-item-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFeatureNewItemFilled;